import { render, staticRenderFns } from "./PermissionManagement.vue?vue&type=template&id=06687163&scoped=true&"
import script from "./PermissionManagement.vue?vue&type=script&lang=js&"
export * from "./PermissionManagement.vue?vue&type=script&lang=js&"
import style0 from "./PermissionManagement.vue?vue&type=style&index=0&id=06687163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06687163",
  null
  
)

export default component.exports